module.exports = "https://dev.stanwinstonschool.com/cowboysandaliens_poster_alt.16aa384165d56c174c71ebd72543d80f.jpg";